import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { calcCount, verify } from './iput/src/helper';

var ip = require('ip');

export default class Validation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {count:null,error:null}
    }
    run(format, value) {
        const error = verify(format, value);
        var count;
        if (!error) {
            count = calcCount(value);
        }
        this.setState({ count, error });
        if (this.props.onValidate) {
            this.props.onValidate(!error);
        }
    }
    render() {
        const { error, count } = this.state;
        return (
            <Grid container justify='space-around' spacing={3}
                alignItems='center' style={{ width: '100%', height: '100px' }}>
                <Typography role='tabpanel' component='div' hidden={!error}>
                    <div style={{ color: 'red' }}>{error}</div>
                </Typography>
                <Typography component={'span'} style={{ width: '100%' }} hidden={error}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>Count</TableCell>
                                <TableCell>{count}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Typography>

            </Grid>
        );
    }
}